var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    fontFamily:
      _vm.$i18n.locale === 'zh-CN'
        ? 'Avenir, Helvetica, Arial, sans-serif'
        : 'English,Avenir, Helvetica, Arial, sans-serif',
  }),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }